export enum ActionBtnTypes {
  TOAST = "toast",
  CHANGE_STATUS = "change_status",
  REDIRECT = "redirect",
  MODAL = "modal",
  VIEW_DOCUMENT = "view_document",
  API_CHECK = "api_check",
  IFRAME = 'iframe',
  RESEND = "resend",
  VOID = 'void',
  REDIRECT_TAB = "redirect_tab",
  POPUPBTN = "popupBtn", 
}

export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error'
}

export interface IBtnsParametersModel {
  parameterName: string;
}

export interface IActionBtnsModel {
  widgetType: string;
  label: string;
  value: string;
  btnType: ActionBtnTypes;
  btnOrder: number;
  sections: string | null;
  moveToStatus: string | null;
  parameters?: IBtnsParametersModel[];
  toastType?: ToastType;
  popupName?: string;
  popupbtnType: popupbtnType;
  editable?:boolean;
  stateVariables:object;
}

export interface IDocuSignDocumentInput {
  orgId: string,
  url: string,
  sections: string,
  screen: string,
}

export interface ISignStatusModel {
  signerName: string
  status: string
  signerEmail: string
  signerDocusignUrl?: string | null;
}
export interface ExpiryDateModel {
  envelopeExpiryFlag: boolean
  envelopeExpiryDate: Date

}
export interface StatusWidgetsInfo {
  showSignatureStatus: boolean
  showApplicationProgress: boolean
  showReviewProgress: boolean
  documentType: string

}
export enum WIDGET_TYPE{
  ACTION_BUTTON = "action_button",
  SIGNATURE_STATUS = "signature_status",
  POPUP_BTN="popup_button", 
}
export enum popupbtnType{  
  APPROVE = "approve",
  DENY = "deny"
}